import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Button, Col, Form, Input, message, Popconfirm, Row, Select } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

import Utils from '../../../Assets/Scripts/Utils';
import {
  applyRegisterCustomFields,
  createRegisterShowField,
  RegisterLayoutBody,
  useRegisterFieldLayout,
} from '../../../Components/ResourceFieldLayout/RegisterFieldLayout';
import { api } from '../../../Services/axiosService';

function OccurrenceRegister() {
  const { id: editId } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [screenModified, setScreenModified] = useState(false);
  const [fieldsPermissions, setFieldsPermissions] = useState();
  const { fieldLayout, roleId } = useRegisterFieldLayout('Occurrence');
  const showField = createRegisterShowField(fieldsPermissions, fieldLayout, roleId);
  const [occurrenceTypes, setOccurrenceTypes] = useState([]);

  const fetchOccurrenceEdit = async (id) => {
    setLoading(true);

    const res = await api
      .get(`/Occurrence?id=${id}`)
      .then((res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os dados!');
      });

    if (res && res.type) {
      res.type = {
        label: res.type.name,
        value: res.type.id,
      };
    }

    form.setFieldsValue(applyRegisterCustomFields(res));
    setLoading(false);
  };

  const fetchOccurrenceTypes = async () => {
    try {
      const response = await api.get(
        '/OccurrenceType?filters[0].Field=Status&filters[0].Condition=DIFFERENT&filters[0].Value=Inativo'
      );
      if (response.data) {
        setOccurrenceTypes(
          response.data.map((type) => ({
            value: type.id,
            label: type.name,
          }))
        );
      }
    } catch (error) {
      Utils.logError(error);
      message.error('Erro ao buscar os Tipos de Ocorrência');
    }
  };

  const onFinish = async (values) => {
    setLoading(true);

    const dataToSend = {
      ...values,
      type: {
        id: values.type.value,
        name: values.type.label,
      },
    };

    const httpMethod = editId ? 'put' : 'post';
    await api[httpMethod]('/Occurrence', dataToSend)
      .then(() => {
        message.success(`Dados ${editId ? 'atualizados' : 'salvos'}!`);
        form.resetFields();

        if (editId) {
          fetchOccurrenceEdit(editId);
        }

        setLoading(false);
        setScreenModified(false);
      })
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Erro ao enviar os dados da Ocorrência!');
        setLoading(false);
      });
  };

  useLayoutEffect(() => {
    const permissions = {};
    JSON.parse(localStorage.getItem('conecta__permissions'))?.resources.forEach(
      ({ name, fields }) => {
        if (name === 'Occurrence') {
          fields.forEach(({ name, access, isRequired }) => {
            permissions[name] = { access, isRequired };
          });
        }
      }
    );
    setFieldsPermissions(permissions);
  }, []);

  useEffect(() => {
    fetchOccurrenceTypes();

    if (editId) {
      fetchOccurrenceEdit(editId);
    }
  }, []);

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      autoComplete="off"
      onChange={() => setScreenModified(true)}
      style={{ maxWidth: '100%', margin: '0 auto' }}
    >
      <div className="form-toolbar">
        {screenModified && (
          <Popconfirm
            title="Deseja mesmo voltar?"
            onConfirm={() => navigate(-1)}
            okText="Sim"
            cancelText="Não"
          >
            <Button>Voltar</Button>
          </Popconfirm>
        )}
        {!screenModified && <Button onClick={() => navigate(-1)}>Voltar</Button>}
        <Button loading={loading} block type="primary" htmlType="submit">
          Salvar
        </Button>
      </div>

      {/* Campos invisiveis */}
      <Form.Item className="input-hidden" label="Id" name="id">
        <Input />
      </Form.Item>

      <Row gutter={[24]}>
        <RegisterLayoutBody
          fieldLayout={fieldLayout}
          fieldsPermissions={fieldsPermissions}
          roleId={roleId}
          widgetMap={{
            Name: () =>
              showField('Name') && (
                <Col span={12}>
                  <Form.Item
                    label="Nome"
                    name="name"
                    rules={[
                      {
                        required: fieldsPermissions?.Name?.isRequired,
                        message: 'Campo obrigatório!',
                      },
                    ]}
                  >
                    <Input disabled={fieldsPermissions?.Name?.access !== 2} />
                  </Form.Item>
                </Col>
              ),
            Type: () =>
              showField('Type') && (
                <Col span={12}>
                  <Form.Item
                    label="Tipo de Ocorrência"
                    name="type"
                    rules={[
                      {
                        required: fieldsPermissions?.Type?.isRequired,
                        message: 'Campo obrigatório!',
                      },
                    ]}
                    getValueFromEvent={(_, object) => {
                      if (!object) return null;

                      return {
                        ...object,
                        name: object.label,
                        id: object.value,
                      };
                    }}
                  >
                    <Select
                      options={occurrenceTypes}
                      allowClear
                      placeholder="Selecione o tipo de ocorrência"
                      optionFilterProp="label"
                      showSearch
                      dropdownStyle={{ borderRadius: 16 }}
                      disabled={fieldsPermissions?.Type?.access !== 2}
                      loading={occurrenceTypes.length === 0}
                    />
                  </Form.Item>
                </Col>
              ),
          }}
          form={form}
          loading={loading}
          padraoFields={
            <>
              {showField('Name') && (
                <Col span={12}>
                  <Form.Item
                    label="Nome"
                    name="name"
                    rules={[
                      {
                        required: fieldsPermissions?.Name?.isRequired,
                        message: 'Campo obrigatório!',
                      },
                    ]}
                  >
                    <Input disabled={fieldsPermissions?.Name?.access !== 2} />
                  </Form.Item>
                </Col>
              )}

              {showField('Type') && (
                <Col span={12}>
                  <Form.Item
                    label="Tipo de Ocorrência"
                    name="type"
                    rules={[
                      {
                        required: fieldsPermissions?.Type?.isRequired,
                        message: 'Campo obrigatório!',
                      },
                    ]}
                    getValueFromEvent={(_, object) => {
                      if (!object) return null;

                      return {
                        ...object,
                        name: object.label,
                        id: object.value,
                      };
                    }}
                  >
                    <Select
                      options={occurrenceTypes}
                      allowClear
                      placeholder="Selecione o tipo de ocorrência"
                      optionFilterProp="label"
                      showSearch
                      dropdownStyle={{ borderRadius: 16 }}
                      disabled={fieldsPermissions?.Type?.access !== 2}
                      loading={occurrenceTypes.length === 0}
                    />
                  </Form.Item>
                </Col>
              )}
            </>
          }
        />
      </Row>
    </Form>
  );
}

export default OccurrenceRegister;
